import React from "react";

const STEP_COLOR = "#121313";
const ACCENT_COLOR = "#78b7e4";

const STEPS = [
  {
    id: "branche",
    number: "01",
    title: "Headhunter für Ihre Branche",
    description:
      "Wir jagen die Köpfe aus Ihrer Branche. Wer mit Repexo Sales arbeitet, dem geht ein wirkliches Licht auf.",
    offset: "0px",
  },
  {
    id: "zeit",
    number: "02",
    title: "Zeit ist Geld",
    description:
      "Wie lange wollen Sie noch auf die wertvollen Köpfe aus Ihrer Branche warten?",
    offset: "34px",
  },
  {
    id: "wertvoll",
    number: "03",
    title: "Echtes Headhunting ist wertvoll!",
    description:
      "Sie wollen Qualität? Sie bekommen Qualität! Bei uns bekommen Sie Sales Headhunting vom Feinsten.",
    offset: "0px",
  },
  {
    id: "klarer-auftrag",
    number: "04",
    title: "Planen Sie mit uns den Erfolg",
    description:
      "Planen Sie mit uns den weiteren Erfolg – mit wertvollen Mitarbeitern, weltweit!",
    offset: "34px",
  },
];

export default function SalesHeadhuntingSection() {
  return (
    <section className=" py-16 mb-0">
      <div className="container-app mx-auto">

     

        {/* Heading – match global h2 style */}
        <h2 className="text-xl sm:text-3xl md:text-4xl font-semibold md:font-medium text-gray-900">
          Echtes Headhunting für den Vertrieb,
          <br className="hidden md:block" />
          so funktioniert es wirklich
        </h2>

        <p className="mt-2 text-base text-gray-600 md:text-lg">
          Hier erfahren Sie, wie wir Vertriebspositionen zielgenau besetzen.
        </p>

        {/* Timeline: card layout on mobile/tablet, snake + wave on desktop */}
        <div className="relative mt-10 lg:mt-16 lg:min-h-[220px]">

          {/* Wave line – desktop only so it doesn’t overlap on mobile */}
          <svg
            className="absolute left-0 -top-[17px] hidden w-full lg:block"
            viewBox="0 0 1000 120"
            preserveAspectRatio="none"
            aria-hidden
          >
            <path
              d="
              M 0 40
              C 25 40 125 80 250 80
              C 375 80 375 40 500 40
              C 625 40 625 80 750 80
              
              "
              fill="none"
              stroke={ACCENT_COLOR}
              strokeWidth="2"
              strokeDasharray="8 6"
              strokeLinecap="round"
            />
          </svg>

          {/* Steps – cards on mobile/tablet; snake offsets from lg */}
          <div className="relative z-10 grid grid-cols-1 gap-y-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-y-10">
            {STEPS.map((step) => (
              <div
                key={step.id}
                className={`relative flex flex-col items-start w-full rounded-2xl bg-white/95  py-6 shadow-[0_10px_30px_rgba(0,0,0,0.06)] border border-neutral-200/80 lg:bg-transparent lg:shadow-none lg:border-none lg:w-[70%] ${
                  step.offset === "34px" ? "lg:mt-[34px]" : ""
                }`}
              >
                {/* Number circle – much smaller, especially on mobile */}
                <div
                  className="flex h-9 w-9 items-center justify-center rounded-full text-xs font-bold text-white md:h-10 md:w-10 md:text-sm lg:h-12 lg:w-12 lg:text-base"
                  style={{
                    backgroundColor: STEP_COLOR,
                    boxShadow: "0 8px 20px rgba(0,0,0,0.18)",
                  }}
                >
                  {step.number}
                </div>

                <h3 className="mt-4 text-base font-semibold text-gray-900 sm:text-lg">
                  {step.title}
                </h3>

                <p className="mt-2 text-sm leading-6 text-gray-600">
                  {step.description}
                </p>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}